import type { SiteConfig } from '../types/index.js';
import { adminRequest } from './admin-api.js';

export const siteConfigAdminService = {
  async getConfig(): Promise<SiteConfig> {
    return adminRequest('/admin/site-config', { method: 'GET' });
  },
  async updateConfig(payload: Partial<SiteConfig>): Promise<SiteConfig> {
    return adminRequest('/admin/site-config', {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
  },
};
